import Common from '../../Common';

interface Options {
	limit?: number
	limit_from?: number
	orderBy?: string
	orderDir?: string
	dateTimeFrom?: string
	dateTimeTo?: string
}

const Log = class extends Common {
	browse = (companyId: id, options?: Options) =>
		this.get(`/company/${companyId}/logger`, options)
}

export default Log;
